import { Series } from '@types';
import { LOCATIONS } from '@utils/locations';

const ROME: Series = {
  id: 'rome',
  name: 'Rome',
  location: LOCATIONS.ROME,
  sortType: 'date_asc',
  groupBy: 'year',
};

export default ROME;
